import React from 'react';
import Layout from '../components/Layout';
import { useLocation, Link } from 'react-router-dom';
import { Check, X } from 'lucide-react';

const ComparePage = () => {
  const location = useLocation();
  const { villas } = location.state || { villas: [] };

  if (villas.length === 0) {
    return (
      <Layout>
        <div className="pt-32 text-center">
          <h2 className="text-2xl font-heading">No villas selected</h2>
          <Link to="/search" className="text-primary underline mt-4 block">Return to Search</Link>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="pt-32 px-6 md:px-12 max-w-7xl mx-auto">
        <h1 className="text-4xl font-heading font-bold mb-12">Compare Villas</h1>
        
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="p-4 text-left w-48">Feature</th>
                {villas.map(v => (
                  <th key={v.id} className="p-4 text-left min-w-[250px]">
                    <img src={v.images[0]} className="w-full h-40 object-cover rounded-lg mb-4" />
                    <div className="font-heading text-xl">{v.name}</div>
                    <div className="text-sm font-normal text-muted-foreground">{v.resort_name}</div>
                    <div className="mt-2 text-xl font-bold">${v.price_per_night}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-border/50">
              <tr>
                <td className="p-4 font-bold text-muted-foreground uppercase text-xs tracking-widest">Type</td>
                {villas.map(v => <td key={v.id} className="p-4">{v.type}</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold text-muted-foreground uppercase text-xs tracking-widest">Bedrooms</td>
                {villas.map(v => <td key={v.id} className="p-4">{v.bedrooms}</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold text-muted-foreground uppercase text-xs tracking-widest">Size</td>
                {villas.map(v => <td key={v.id} className="p-4">{v.size_sqm} m²</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold text-muted-foreground uppercase text-xs tracking-widest">Pool</td>
                {villas.map(v => <td key={v.id} className="p-4">{v.has_pool ? <Check className="text-green-500"/> : <X className="text-muted-foreground"/>}</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold text-muted-foreground uppercase text-xs tracking-widest">View</td>
                {villas.map(v => <td key={v.id} className="p-4">{v.view_type}</td>)}
              </tr>
              <tr>
                <td className="p-4 font-bold text-muted-foreground uppercase text-xs tracking-widest">Amenities</td>
                {villas.map(v => (
                  <td key={v.id} className="p-4 align-top">
                    <ul className="text-sm space-y-1">
                      {v.amenities.slice(0, 5).map(a => <li key={a}>• {a}</li>)}
                    </ul>
                  </td>
                ))}
              </tr>
              <tr>
                <td className="p-4"></td>
                {villas.map(v => (
                   <td key={v.id} className="p-4">
                     <button className="bg-primary text-white px-6 py-3 rounded-full text-xs font-bold uppercase tracking-widest w-full">Book</button>
                   </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default ComparePage;
